import React from 'react';
import { CardBody, CardFooter } from 'reactstrap';
import { Form, Button, Field } from '@cordata/buffet';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import { object, string, array } from 'yup';

import usePatient from '~/utils/patient/hook';
import { authorizedPyInstance } from '~/utils';

const validationSchema = object().shape({
  disputeComment: string().required(),
  sitenames: array().min(1).required(),

});

const DisputePatientMatchForm = ({
  afterSubmit,
}) => {
  const params = useParams();
  const [, patient, actions] = usePatient();

  const submitDispute = (values) => {
    const payload = {
      'dispute-comment': values.disputeComment,
      sitenames: values.sitenames.map(v => v.sitename),
    };

    authorizedPyInstance
      .post(
        `/api/data/public/identity/patient/${params.patient_id}/dispute`,
        payload,
      )
      .then(() => {
        actions.audit('Dispute');
        actions.refresh();
        afterSubmit();
      });
  };

  const sources = patient.matchResults.matches.reduce((acc, obj) => {
    const existing = find(acc, item => item.sitename === obj.sitename);
    if (!existing) {
      acc.push({
        sourceDescription: obj.sourceDescription,
        sitename: obj.sitename,
        hasDisputed: obj.isDisputed,
      });
    } else if (!existing.hasDisputed && obj.isDisputed) {
      existing.hasDisputed = true;
    }

    return acc;
  }, []);

  return (
    <Form
      initialValues={{
        disputeComment: '',
        sitenames: [],
      }}

      validationSchema={validationSchema}

      onSubmit={(values) => {
        submitDispute(values);
      }}
    >
      {() => (
        <>
          <CardBody className="py-0">
            <p>
              You have indicated that you believe the medical record data matched
              to the child welfare record is incorrect. This means that you have
              reason to suspect that the medical record data displayed is for the
              wrong child. Once submitted, the medical information for this child
              will no longer be displayed until the dispute is resolved.
            </p>

            <hr />

            <Field
              name="disputeComment"
              label="I believe this child welfare record is matched to the wrong medical record because"
              placeholder="Dispute reason..."
              type="textarea"
              required
            />

            <Field
              name="sitenames"
              label="Sources to dispute"
              type="checkbox-group"
              options={sources.filter(source => !source.hasDisputed)}
              getOptionValue={o => o.sitename}
              getOptionLabel={o => o.sourceDescription}
              required
            />
          </CardBody>

          <CardFooter className="d-flex">
            <div className="ml-auto">
              <Button type="cancel" onClick={afterSubmit}>
                Cancel
              </Button>

              <Button type="submit">
                Dispute
              </Button>
            </div>
          </CardFooter>
        </>
      )}
    </Form>
  );
};

DisputePatientMatchForm.propTypes = {
  afterSubmit: PropTypes.func.isRequired,
};

export default DisputePatientMatchForm;
